import React, { useContext } from 'react';
import styled from 'styled-components';
import { Context } from '@components/Context';
import FlexPDPHoverOverlay from '@components/products/FlexPDPHoverOverlay';
import ProductExpressBuy from '@components/products/ProductExpressBuy';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import WaitlistPaymentRender from '@components/products/WaitlistPaymentRender';
import { CartItemType } from '@contracts';
import PayPalMessage from './PayPalMessage';

const ShoppingModule: React.FC = () => {
  const showPaypal = process.env.SHOW_PAYPAL === 'true';
  const { selectedOptionCartItem, selectedAddonCartItems } = useShoppingContext();
  const { state } = useContext(Context);
  const guestCheckoutExcludedTypes = [CartItemType.Subscription, CartItemType.Consultation];

  function hasCartItemTypeIntersection(array1: CartItemType[], array2: CartItemType[]) {
    return array1.some((item) => array2.includes(item));
  }

  function shouldShowProductExpressBuyButtons() {
    // Case 1: User is logged in and not anonymous
    if (state.loggedIn && !state.userIsAnonymous) {
      return true;
    }

    // Case 2: User is not logged in OR logged in as anonymous
    if (!state.loggedIn || (state.loggedIn && state.userIsAnonymous)) {
      const addonTypes = selectedAddonCartItems.map((addOn) => addOn.type);
      // Show button only if the cart item is not a subscription
      return (
        selectedOptionCartItem &&
        !guestCheckoutExcludedTypes.includes(selectedOptionCartItem?.type) &&
        !hasCartItemTypeIntersection(addonTypes, guestCheckoutExcludedTypes)
      );
    }

    // In all other cases, hide the button
    return false;
  }

  return (
    <Container>
      <WaitlistOrPaymentOptionsContainer>
        <WaitlistPaymentRender />
      </WaitlistOrPaymentOptionsContainer>
      <FlexPDPHoverOverlay />
      {shouldShowProductExpressBuyButtons() ? <ProductExpressBuy /> : null}
      {showPaypal ? <PayPalMessage /> : null}
    </Container>
  );
};

export default ShoppingModule;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const WaitlistOrPaymentOptionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
